const channelCodeName='channelCode';//渠道码用到的字段名（埋点统计）
const businessTypes=[
    { name: 'PDF服务', value: 'PDF_FORWARD_SERVICE'},
    { name: '网页取证', value: 'EVIDENCE_WEBPAGE', detailUrl:'/evidence/simple' },
    { name: '网页取证（增强版）', value: 'EVIDENCE_WEBPAGE_PLUS',detailUrl:'/selenoid'},
    { name: '录屏取证', value: 'EVIDENCE_RECORD_SCREEN',detailUrl:'/vm_fetch' },
    { name: '境外取证', value: 'EVIDENCE_RECORD_OVERSEAS',detailUrl:'/overseas' },
    { name: '自动录屏取证', value: 'EVIDENCE_VIDEO',detailUrl:'/autoMatic/video' },
    { name: '在线音频/视频取证', value: 'EVIDENCE_ONLINE_AUDIO_VIDEO',detailUrl:'/autoMatic/video' },
    { name: '微信公众号取证', value: 'EVIDENCE_WECHAT',detailUrl:'/autoMatic/wxauto' },
    { name: '手机自动取证', value: 'EVIDENCE_PHONE',detailUrl:'/autoMatic/wxauto' },
    { name: '权利卫士-拍照取证', value: 'GUARD_TAKE_PHOTO',detailUrl:'/qlws', evidenceType:1},
    { name: '权利卫士-录像取证', value: 'GUARD_RECORD_VIDEO',detailUrl:'/qlws',evidenceType:2},
    { name: '权利卫士-录音取证', value: 'GUARD_RECORD_AUDIO',detailUrl:'/qlws',evidenceType:3},
    { name: '权利卫士-网页取证', value: 'GUARD_EVIDENCE_WEBPAGE',detailUrl:'/qlws',evidenceType:4},
    { name: '权利卫士-录屏取证', value: 'GUARD_RECORD_SCREEN',detailUrl:'/qlws',evidenceType:5},
    { name: '知识产权-可信时间戳认证', value: 'COPYRIGHT',detailUrl:'/time/FileDetail' },
    { name: '知识产权-版权认证证书生成', value: 'COPYRIGHT_AUTHENTICATION',detailUrl:'/copyright/copyrightAuthDetail'},
    { name: '知识产权-存储服务', value: 'COPYRIGHT_STORAGE' ,detailUrl:'/time/FileDetail'},
    { name: 'AIGC 创作过程认证', value: 'COPYRIGHT_AIGC',detailUrl:'/time/FileDetail' },
    { name: '邮件认证-可信时间戳认证', value: 'EMAIL_PROOF' ,detailUrl:'/emailProof/witnessEmailDetail'},
    { name: '邮件认证-存储服务', value: 'EMAIL_PROOF_STORAGE' ,detailUrl:'/emailProof/witnessEmailDetail'},
    { name: '软著登记保护-可信时间戳认证', value: 'SOFTWARE_COPYRIGHT',detailUrl:'/time/FileDetail' },
    { name: '软著登记保护-存储服务', value: 'SOFTWARE_COPYRIGHT_STORAGE',detailUrl:'/time/FileDetail' },
    { name: '知识产权-软著认证证书生成', value: 'SOFTWARE_COPYRIGHT_AUTHENTICATION',detailUrl:'/system/copyrightAuthDetail' },
];
export {
    channelCodeName,
    businessTypes
}